import React from 'react';
import ReactPlayer from 'react-player';
import '../assets/styles/Music.css';
import { MusicData } from '../interfaces';

export default class Post extends React.Component<MusicData, {
	height: number
	width: number
}> {

	private containerRef: React.RefObject<HTMLDivElement> = React.createRef();
	public state = {
		height: 0,
		width: 0
	}

	private updateSize = () => {
		let ratio = this.props.ratio || 2.76; //16 / 9;
		if (this.containerRef.current) this.setState({
			height: this.containerRef.current.offsetWidth / ratio,
			width: this.containerRef.current.offsetWidth
		});
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateSize);
	}

	componentDidMount() {
		this.updateSize();
		window.addEventListener('resize', this.updateSize);
	}

	render() {
		let element = (
			<div className={'post portfolio-text'} ref={this.containerRef}>
				<h1>{this.props.title}</h1>
				<h2>
					{[
						this.props.subtitle,
						this.props.location,
						this.props.date,
						this.props.instrument
					].filter(v => v).map((v, i) => <p
						key={['metadata', i].join('.')}
						className={'metadata'}
					>{v}</p>)}
				</h2>
				<div className='container' style={{
					//maxHeight: this.state.height * 0.645				
				}}>
					<ReactPlayer
						url={this.props.url}
						width={this.state.width}
						height={this.state.height}
						//light
						playsinline
						controls
					/>
				</div>
			</div>
		);
		return element;
	}

}